import { render, staticRenderFns } from "./review-box.vue?vue&type=template&id=5e5acb8a&scoped=true&"
import script from "./review-box.vue?vue&type=script&lang=js&"
export * from "./review-box.vue?vue&type=script&lang=js&"
import style0 from "./review-box.vue?vue&type=style&index=0&id=5e5acb8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5acb8a",
  null
  
)

export default component.exports